export const colors = {
  primary: "#3b82f6",      // main blue (charts, bars)
  primarySoft: "#93c5fd",  // lighter version
  accent: "#0ea5e9",       // optional cyan (use sparingly)
  
  success: "#16a34a",
  warning: "#f59e0b",
  
  textPrimary: "#111827",
  textSecondary: "#6b7280",
   textMuted: "#f8fafc",
  border: "#e5e7eb",
  background: "#f8fafc"
};

export {}; 